import { Component } from '@angular/core';

@Component({
  selector: 'app-logout-confirmation',
  templateUrl: './logout-confirmation.component.html',
  styleUrls: ['./logout-confirmation.component.scss'],
})
export class LogoutConfirmationComponent {
  constructor() {}
}
